import { RolesPermissionState } from './roles-permissions.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ROLES_PERMISSION_KEY } from './roles-permissions.reducer';

// Lookup the 'Auth' feature state managed by NgRx
const getAuthState = createFeatureSelector<RolesPermissionState>(ROLES_PERMISSION_KEY);

export const getPermissions = createSelector(
    getAuthState,
    state => state.permissions.authorities
);

export const getRole = createSelector(
    getAuthState,
    state => state.permissions.role
);

export const isLoading = createSelector(
    getAuthState,
    state => state.loading
);

export const isError = createSelector(
    getAuthState,
    state => state.error
);

